import { ThemeView } from '@/components/Theme';
import { StyleSheet } from "react-native";

const CardFooter = (props) => {
        
    const {
        children = null,
        style = null,
        light = 'muted.50',
        dark = 'muted.1000',
    } = props;

    return (
        <ThemeView light={light} dark={dark} style={[styles.container, style]}>
            {children}
        </ThemeView>
    );
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 15,
        paddingVertical: 10,
    }
});

export default CardFooter;